import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@99designs/common/components/Button';
import { PopoverCard } from '@99designs/common/components/PopoverCard';
import { FormattedMessage } from 'react-intl';
import onboardingPrompt from 'contest/components/onboarding-prompts/onboardingPrompt';

const GroupByPotentialFinalistPrompt = ({ dismiss, children }) => {
    return (
        <PopoverCard
            layerSelector="#content-overlay-layer"
            variations={['onboarding-prompt']}
            card={
                <div>
                    <p>
                        <FormattedMessage id="group_by_designer_button_onboarding_message" />
                    </p>
                    <Button variations={['info', 'small']} onClick={dismiss}>
                        <FormattedMessage id="group_by_designer_button_onboarding_dismiss" />
                    </Button>
                </div>
            }
        >
            <span onClick={dismiss}>{children}</span>
        </PopoverCard>
    );
};

GroupByPotentialFinalistPrompt.propTypes = {
    dismiss: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default onboardingPrompt('group-by-designer-control', 500, GroupByPotentialFinalistPrompt);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/GroupByPotentialFinalistPrompt.js